<template>
  <div class="voucher-list">
    <mm-spinner :visible="loading" />
    <mm-table
      :columns="columns"
      :data-source="voucherList"
    />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  export default {
    data() {
      return {
        loading: true,
        columns: [
          {
            title: this.$t('voucher.expiration'),
            key: 'expired_time',
            width: 150
          },
          {
            title: this.$t('voucher.source'),
            key: 'source',
          },
          {
            title: this.$t('voucher.denomination'),
            key: 'amount',
            width: 120
          },
          {
            title: this.$t('voucher.limit'),
            key: 'remark',
            width: 150,
          },
          {
            title: this.$t('voucher.status'),
            key: 'status',
            width: 100
          },
        ],
      }
    },
    async created() {
      await this.fetchVoucherList({
        client_id: this.clientId
      })
      this.loading = false
    },
    computed: {
      ...mapState('voucher', ['voucherList']),
      ...mapState('main', {
        clientId(state) {
          return state.userInfo.user.client_id
        }
      })
    },
    methods: {
      ...mapActions('voucher', ['fetchVoucherList']),
    },
  }
</script>

<style>
  .voucher-list {
    min-height: 200px;
    padding: 2rem;
  }
</style>

